export const SPACE_CATEGORIES = [
    "Social",
    "Debate",
    "Learning",
    "Technology",
    "Creative",
    "News",
    "Science",
    "Books",
    "Games",
    "Business",
    "Finance",
    "Support",
    "Places",
    "Productivity",
    "Anonymous",
    "Private",
    "Archive",
    "Events",
    "Culture",
    "Other",
] as const;

export const JOINED_SPACE_FILTERS = ["All", ...SPACE_CATEGORIES, "New", "Popular"] as const;
export const DISCOVERY_SPACE_FILTERS = ["All", ...SPACE_CATEGORIES] as const;

export const SPACE_ACCENTS = [
    "#22d3ee",
    "#a78bfa",
    "#34d399",
    "#f472b6",
    "#f59e0b",
    "#60a5fa",
    "#fb7185",
    "#c084fc",
    "#2dd4bf",
    "#facc15",
] as const;
